module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_8017.45e036c4.png";